import styled from "styled-components"

export const CardStyled = styled.section`
  margin-top: 20px;

  input,
  button {
    width: 100%;
  }

  button {
    margin-top: 20px;
  }
  
  .empty-btn {
    margin-bottom: 30px;
  }
`
